import React from 'react';
import { Check, X } from 'lucide-react';
import { PASSWORD_RULES } from '../../utils';

/**
 * Real-time password requirements checklist.
 * Shows green checks / red X for each rule as the user types.
 *
 * Only renders when `password` is non-empty so the checklist
 * doesn't flash before the user starts typing.
 */
const PasswordRequirements = ({ password }) => {
  if (!password) return null;

  return (
    <ul className="mt-2 space-y-1">
      {PASSWORD_RULES.map((rule) => {
        const passed = rule.test(password);
        return (
          <li
            key={rule.id}
            className={`flex items-center gap-1.5 text-xs font-medium ${passed ? 'text-green-600' : 'text-red-500'
              }`}
          >
            {passed ? <Check size={14} aria-hidden="true" /> : <X size={14} aria-hidden="true" />}
            <span className="sr-only">{passed ? 'Passed: ' : 'Not met: '}</span>
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
};

export default PasswordRequirements;
